<h2 mat-dialog-title>Edit Content</h2>
<form [formGroup]="form" (ngSubmit)="onSave()">
  <div mat-form-field appearance="fill" class="full-width">
    <div mat-label>Content</div>
    <textarea matInput rows="4" formControlName="newText"></textarea>
    <div mat-hint align="end">{{ form.get('newText')?.value.length }} / 1000</div>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid || loading">
      Save
      <div mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="20"></div>
    </button>
  </div>

  <p *ngIf="statusMessage" class="status">{{ statusMessage }}</p>
</form>
